// Interfaces
export interface ReleaseNotes {
  releaseId: string;
  productId: string;
  title: string;
  version: string;
  tentativeReleaseAt: string | number;
  publishedAt?: string | number;
  updatedBy: string;
  summaryText: string;
  mediaType: string;
  mediaS3Path: string;
  mediaUrl: string;
  modifiedBy: string;
  modifiedDate: string;
  status: string;
}

export interface ProductVersionInfo {
  product: string;
  version: string;
  fileName: string;
  releaseId?: string;
}

export interface PresignedURLObject {
  isSuccess: boolean;
  message: string;
  uploadUrl: string;
  objectKey: string;
}

export interface FileUpload {
  name: string;
  type: string;
  preview: string;
  file: File;
}

export interface ProductListResponse {
  products: string[];
}

export interface ReleaseNoteResponse {
  items: ReleaseNotesDetail[];
  page: number;
  totalCount: number;
}

export interface ReleaseNotesDetail {
  releaseId: string;
  productId: string;
  version: string;
  title: string;
  status: string;
  publishedAt: string;
  tentativeReleaseAt: number;
  modifiedBy: string;
  modifiedAt: number;
}

export interface ReleaseNotesFormValue {
  releaseId: string | null;
  productId: string | null;
  title: string;
  version: string;
  tentativeReleaseAt: Date | null;
  summaryText: string;
  fileUpload: string | File | null;
}

// ENUMs

// Constants
export const IMAGE_MAX_SIZE = 4 * 1024 * 1024;
export const VIDEO_MAX_SIZE = 20 * 1024 * 1024;

export const IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];
export const VIDEO_TYPES = ['video/mp4'];

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: { day: 'numeric', month: 'numeric', year: 'numeric' },
  },
  display: {
    dateInput: { day: '2-digit', month: '2-digit', year: 'numeric' },
    monthYearLabel: { month: 'short', year: 'numeric' },
    dateA11yLabel: { day: 'numeric', month: 'long', year: 'numeric' },
    monthYearA11yLabel: { month: 'long', year: 'numeric' },
  },
};
